import { Component } from '@contorion/core/components';
import { element as $ } from '@contorion/core';

const SELECTOR_TIME: string = '.js-countdown';
const SELECTOR_TEXT_VALUE: string = '.js-countdown-text';

export class CountdownComponent extends Component {
    private timer?: number;

    protected get text(): HTMLDivElement {
        return <HTMLDivElement> $(SELECTOR_TIME, this.element.parentElement);
    }

    protected get textValue(): HTMLSpanElement {
        return <HTMLSpanElement> $(SELECTOR_TEXT_VALUE, this.element.parentElement);
    }

    protected get timeNow(): number {
        return Math.floor(new Date(Date.now()).valueOf() / 1000);
    }

    protected get timeEnd(): number {
        let endTime:string = this.element.dataset.endTime;

        return Math.floor(Date.parse(endTime) / 1000);
    }

    protected get timeDiff(): number {
        return this.timeEnd - this.timeNow;
    }

    protected timeCalc(): string {
        const timeDiff: number = this.timeDiff;
        const minute: number = 60;
        const hour: number = minute * 60;
        const day: number = hour * 24;

        const days: number = Math.floor(timeDiff / day);
        const hours: number = Math.floor(timeDiff % day / hour);
        const minutes: number = Math.floor(timeDiff % hour / minute);
        const seconds: number = timeDiff % minute;
        let timeMap: Array<number> = [days, hours, minutes, seconds];

        return this.timeFormat(timeMap);
    }

    protected timeFormat(timeRaw: Array<number>): string {
        let timeFormatted: Array<string> = [];

        timeRaw.forEach((digit: number) => {
            let formattedNumber: string = digit.toString().padStart(2, '0');
            timeFormatted = timeFormatted.concat([formattedNumber]);
        });

        return timeFormatted.join(' : ').toString();
    }

    constructor(protected element: HTMLElement) {
        super(element);
        this.animate();
    }

    protected animate(): void {
        const tick = () => {
            const now: number = Date.now();
            const nowSec: number = this.timeNow;
            const timeDiff: number = this.timeDiff;

            if (timeDiff < 0) {
                delete this.timer;

                return;
            }

            this.textValue.innerHTML = this.timeCalc();

            const timeToNextSecond: number = (nowSec + 1) * 1000 - now;
            window.setTimeout(tick, timeToNextSecond);
        };

        tick();
    }
}
